import { useState } from 'react'

const validateField = (value: string, fieldType?: string) => {
  if (!value.trim()) return "This field cannot be empty";
  if (fieldType !== "comment" && value.length > 8) return "Must be at most 8 characters";
  if (/^[ ]/.test(value)) return "Cannot start with a space or underscore ()";
  if (/[ ]$/.test(value)) return "Cannot end with a space or underscore ()";
  if (/\s{2,}/.test(value)) return "Double spaces are not allowed.";
  
  // Special validation for amount field
  if (fieldType === "amount") {
    const numericValue = parseFloat(value);
    if (!isNaN(numericValue) && numericValue > 999999) {
      return "Amount cannot be more than 999,999";
    }
  }
  return "";
};

export const useManualExpenseValidation = () => {
  const [errors, setErrors] = useState({
    impressions: "",
    clicks: "",
    amount: "",
    comment: "",
  });

  const validate = (field: "impressions" | "clicks" | "amount" | "comment", value: string) => {
    const error = validateField(value, field);
    setErrors((prev) => ({ ...prev, [field]: error }));
    return error;
  }

  const validateAll = (values: { impressions: any; clicks: any; amount: any; comment: any }) => {
    const newErrors = {
      impressions: validateField(values.impressions, "impressions"),
      clicks: validateField(values.clicks, "clicks"),
      amount: validateField(values.amount, "amount"),
      comment: validateField(values.comment, "comment"),
    };
    setErrors(newErrors);
    return Object.values(newErrors).every((e) => e === "");
  };

  const resetErrors = () => {
    setErrors({ impressions: "", clicks: "", amount: "", comment: "" });
  };

  return {
    errors,
    validate,
    validateAll,
    resetErrors,
  };

}

